import Icon from '../components/Icon.vue'

Icon.register({
  leaf: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M546.2 9.7C540.6-2.8 524.6-3.3 517.9 8.5 486.9 62.4 431.4 96 368 96H288C182 96 96 182 96 288 96 295 96.8 301.7 97.5 308.5 161.3 262.8 253.4 224 384 224 392.8 224 400 231.2 400 240S392.8 256 384 256C132.6 256 26 410.1 2.4 468-4.2 484.3 3.6 502.9 19.9 509.6 36.3 516.4 54.9 508.5 61.7 492.3 63.2 488.7 82.6 444.4 133.6 401.7 166 445.6 227.6 487.5 308.5 478.9 465.5 467.5 576 326.7 576 154.3 576 104.1 565.2 52.1 546.2 9.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/leaf.js
// module id = YPMp
// module chunks = 144